import { Component, Input } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';

/** Icon-only copy button for a value shown as plain text; same toasts as bst-copiable. */
@Component({
  selector: 'bst-intake-copy',
  template: `<button nbButton ghost size="tiny" status="basic" type="button"
    [nbTooltip]="(label || 'copytoclipboard') | translate" [attr.aria-label]="(label || 'copytoclipboard') | translate"
    (click)="copy()"><nb-icon icon="clipboard-outline"></nb-icon></button>`,
  // 16px icon in a 32px target; under 768px an invisible ring widens the target to 44px
  // without pushing the row open.
  styles: [`
    button { position: relative; min-width: 32px; min-height: 32px; padding: 0; justify-content: center; }
    :host [nbButton].size-tiny nb-icon { font-size: 1rem; width: 1rem; height: 1rem; margin: 0; }
    @media (max-width: 767px) { button::after { content: ''; position: absolute; inset: -6px; } }
  `],
  standalone: false
})
export class IntakeCopyComponent {
  @Input() text: string;
  /** Translation key naming what is copied, for the label and tooltip. */
  @Input() label: string = null;

  constructor(private clipboard: Clipboard, private translate: TranslateService, private toastr: NbToastrService) {}

  copy(): void {
    if (!this.text) { return; }
    const ok = this.clipboard.copy(this.text);
    this.toastr[ok ? 'success' : 'danger'](null, this.translate.instant(ok ? 'textcopied' : 'copyerror'), { icon: 'clipboard' });
  }
}
